import React, { ReactElement } from 'react';
import { Typography, Box, SxProps } from '@mui/material';

type SectionHeaderProps = {
  id?: string;
  title: string;
  subTitle?: string | ReactElement;
  container?: SxProps;
};

/**
 * @deprecated use SectionHeader from common/ui
 */
export const SectionHeader: React.FC<SectionHeaderProps> = ({
  id,
  title,
  subTitle,
  container = { width: '312px' }
}) => {
  return (
    <Box sx={container} id={id}>
      <Typography variant="h5">{title}</Typography>
      {subTitle && typeof subTitle === 'string' ? (
        <Typography variant="body1" whiteSpace="pre-wrap" mt={1}>
          {subTitle}
        </Typography>
      ) : (
        subTitle
      )}
    </Box>
  );
};
